import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56df50ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "articles" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Latest Articles", -1))
const _hoisted_3 = { class: "articles-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Article = _resolveComponent("Article")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
        return (_openBlock(), _createBlock(_component_Article, {
          key: article.address,
          article: article
        }, null, 8, ["article"]))
      }), 128))
    ])
  ]))
}